export const SyncEntities = {
	external_terminals: 1,
	external_terminals_links: 2,
};
